import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const CertificateNationalityModal = (props) => (
  <RequestDetailModal {...props} />
);

export default CertificateNationalityModal;
